import { IconProps } from './types';

export function SadFace({ size, ...props }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 41 41" fill="none" {...props}>
      <path
        d="M28.5 28.5C28.5 28.5 25.5 24.5 20.5 24.5C15.5 24.5 12.5 28.5 12.5 28.5M14.5 14.5H14.52M26.5 14.5H26.52M40.5 20.5C40.5 31.5457 31.5457 40.5 20.5 40.5C9.4543 40.5 0.5 31.5457 0.5 20.5C0.5 9.4543 9.4543 0.5 20.5 0.5C31.5457 0.5 40.5 9.4543 40.5 20.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
